import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { ModalComponent } from 'ngx-boot-modal';

@Component({
  selector: 'app-confirm-modal',
  templateUrl: './confirm-modal.component.html',
  styleUrls: ['./confirm-modal.component.css']
})
export class ConfirmModalComponent {
  @Input() message: string;
  @Input() messageParams = {};
  @Input() confirmLabel = 'shared.confirm.confirm';
  @Input() cancelLabel = 'shared.confirm.cancel';
  @Input() sendCancelWhenClosed = true;
  @Output() confirm = new EventEmitter<void>();
  @Output() cancel = new EventEmitter<void>();
  @ViewChild(ModalComponent) modal: ModalComponent;

  open() {
    this.modal.open();
  }

  onClose() {
    if (this.sendCancelWhenClosed) {
      this.onCancel();
    }
  }

  onCancel() {
    this.cancel.emit();
    this.modal.close();
  }

  onConfirm() {
    this.confirm.emit();
    this.modal.close();
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/shared/components/modals/confirm-modal/confirm-modal.component.ts